'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');
module.exports = function AccountPageController(authenticationModel, subscriptionModel, navigatorShim, subteamModel, affiliateTeamIdentityProvider, optional) {
	const self = observable(this),
		isPersonalSignup = () => {
			const qs = navigatorShim.getQueryStringAsMap();
			return (qs && qs.personalSignup);
		},
		completeEnableMicrosoftTeams = () => {
			const qs = navigatorShim.getQueryStringAsMap();
			return (qs && qs.completeEnableMicrosoftTeams);
		},
		getSuggestedEmail = () => {
			const qs = navigatorShim.getQueryStringAsMap();
			return (qs && qs.suggestedEmail);
		};
	self.start = function () {
		const suggestedEmail = getSuggestedEmail(),
			showPersonalSignup = isPersonalSignup();
		if (suggestedEmail) {
			authenticationModel.setSuggestedEmail(suggestedEmail);
		}
		return Promise.resolve()
		.then(() => {
			if (optional && optional.reauthenticator) {
				return optional.reauthenticator.reauthenticate()
				.catch(() => true);
			}
		})
		.then(async () => {
			if (showPersonalSignup) {
				return subscriptionModel.showPersonalAccountSignup();
			} else if (completeEnableMicrosoftTeams()) {
				await affiliateTeamIdentityProvider.enableMicrosoftTeams(); //{popupAuthEvent: 'popup-auth-required'});
				if (optional && optional.reauthenticator) {
					try {
						await optional.reauthenticator.reauthenticate();
						navigatorShim.clearQueryString();
						return subteamModel.reloadTeamList();
					} catch (error) {
						console.error(error);//eslint-disable-line
					}
				}
			}
		});
	};
	subscriptionModel.addEventListener('goldAccountInfo', (goldAccountInfo) => {
		if (goldAccountInfo && goldAccountInfo.active && isPersonalSignup()) {
			navigatorShim.clearQueryString();
		}
		subteamModel.start(goldAccountInfo);
	});
};
